import { getHeroImageUuid, getSelectionPriceCents, isValidCombinationSelection, } from '@heirloom/common/domain/listing';
export const getOrderItemDisplayData = (item) => {
    const variations = Object.entries(item.selectedOptions).flatMap(([varId, optId]) => {
        const variation = item.listingData.variations[varId];
        if (!variation)
            return [];
        const option = variation.options[optId];
        if (!option)
            return [];
        return [{ name: variation.name, value: option.name }];
    });
    return {
        title: item.listingData.title,
        shopName: item.listingData.shopTitle ?? '',
        shopShortId: item.listingData.shopShortId,
        shippingPriceCents: item.listingData.shippingPrice ?? 0,
        imageUuid: getHeroImageUuid(item.listingData, item.selectedOptions),
        unitPriceCents: calculateItemPrice(item.listingData, item.selectedOptions, item.personalizationText),
        quantity: item.quantity,
        estimatedDelivery: item.listingData.deliveryEstimate ?? null,
        variations,
        personalizationText: item.personalizationText ?? null,
        personalizationName: item.listingData.personalizationName ?? null,
    };
};
export const calculateItemPrice = (listingData, selectedOptions, personalizationText) => {
    return getSelectionPriceCents(listingData, selectedOptions, personalizationText
        ? listingData.personalizationCostCents
        : null);
};
export const isCartItemValid = (selectedOptions, listingData, personalizationText) => {
    if (!listingData)
        return false;
    if (!listingData.available)
        return false;
    if (personalizationText &&
        listingData.personalizationName == null)
        return false;
    return isValidCombinationSelection(selectedOptions, listingData);
};
